module.exports = __webpack_public_path__ + "img/Produktbeispiel_1.e4974a6f.jpg";